<template>
    <div class="funding-details-link d-flex align-items-center justify-content-end">
        <ob1-liens-icone
            mini
            is-button
            icon="icon-info-alt"
            :title="text"
            @click="$emit('fundingDetailsClick', versionSeoId)"
        />
    </div>
</template>

<script>

export default {
    props: {
        versionSeoId: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    }
}
</script>
